import { render, staticRenderFns } from "./PushGroupsApplicationsFilter.vue?vue&type=template&id=228a8392&"
import script from "./PushGroupsApplicationsFilter.vue?vue&type=script&lang=ts&"
export * from "./PushGroupsApplicationsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports